import {useEffect, useRef} from 'react';

import {Button, IconButton, Tooltip} from '@mui/material';
import {bool, func, number, string, node} from 'prop-types';

import {BREAKPOINTS} from '../../../../../const';
import useBreakpoint from '../../../../../hooks/dom/useBreakpoint';

const HoldButton = ({delta, onChange, onStop, disabled = false, tooltip = '', children}) => {
  const holdTimeout = useRef(null);
  const holdInterval = useRef(null);
  const speedRef = useRef(300);

  const breakpoint = useBreakpoint();
  const isExtraSmallScreen = breakpoint === BREAKPOINTS.xs;

  const startHold = () => {
    onChange(delta);
    speedRef.current = 300;

    const run = () => {
      onChange(delta);
      speedRef.current = Math.max(50, speedRef.current * 0.8); // accelerate
      holdInterval.current = setTimeout(run, speedRef.current);
    };

    holdTimeout.current = setTimeout(run, speedRef.current);
  };

  const stopHold = () => {
    console.log('Stop hold');
    clearTimeout(holdTimeout.current);
    clearTimeout(holdInterval.current);
    holdTimeout.current = null;
    holdInterval.current = null;
    if (onStop) onStop();
  };

  const ButtonComponent = isExtraSmallScreen ? IconButton : Button;

  return (
    <Tooltip title={tooltip} placement="right">
      <span>
        <ButtonComponent
          disabled={disabled}
          variant="outlined"
          sx={{background: 'white', borderColor: '#b3bdd2', borderRadius: 5, width: {xs: '30', sm: 'auto'}}}
          onMouseDown={() => !disabled && startHold()}
          onMouseUp={stopHold}
          onMouseLeave={stopHold}
          onTouchStart={() => !disabled && startHold()}
          onTouchEnd={stopHold}
        >
          {children}
        </ButtonComponent>
      </span>
    </Tooltip>
  );
};

HoldButton.propTypes = {
  delta: number.isRequired,
  onChange: func.isRequired,
  onStop: func.isRequired,
  disabled: bool,
  tooltip: string,
  children: node.isRequired
};

export default HoldButton;
